/**
 * Aviso que ocupa o lugar da sala na guia enquanto ela está na janela flutuante.
 */
import { PictureInPicture2 } from 'lucide-react';

/** @param {{ onBringBack: () => void }} props */
export function PoppedOutNotice({ onBringBack }) {
    return (
        <div className="dark flex min-h-0 flex-1 flex-col items-center justify-center gap-4 bg-black p-6 text-center text-neutral-50">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-cyan-500/15 text-cyan-300">
                <PictureInPicture2 className="h-6 w-6" aria-hidden="true" />
            </span>
            <div>
                <p className="text-base font-semibold">A chamada está em uma janela flutuante</p>
                <p className="mt-1 text-sm text-neutral-400">Você pode usar outros programas com ela à vista.</p>
            </div>
            <button
                type="button"
                onClick={onBringBack}
                className="rounded-lg bg-cyan-500 px-4 py-2 text-sm font-semibold text-neutral-950 hover:bg-cyan-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
                Trazer de volta para esta guia
            </button>
        </div>
    );
}
